import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import SimpleFormat from '@16g/react-simple-format'
import BookNowButton from '../../ui/BookNowButton'
import Slider from '../../ui/Slider'
import extractSlidesFromAddOn from '../util/extractSlidesFromAddOn.js'


@inject("modalContainer")
@observer
export default class AddOnModal extends React.Component {
  static propTypes = {
    addOn: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    modalContainer: PropTypes.any.isRequired,
    showPrice: PropTypes.bool.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired
  }

  render() {
    const { show, onClose, modalContainer, addOn, showPrice, formattedPrice, showBookNowButton, bookNowButtonText } = this.props

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        container={modalContainer}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ addOn.attributes.name }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={8}>
              <Slider slides={extractSlidesFromAddOn(addOn)} />
            </Col>
            <Col sm={4}>
              <SimpleFormat text={addOn.attributes.description} />

              { (showPrice && formattedPrice) &&
                <div style={styles.price}>
                  { formattedPrice }
                </div>
              }
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <BookNowButton showBookNowButton={showBookNowButton} bookNowButtonText={bookNowButtonText} />
          <Button onClick={onClose} >Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const styles = {
  price: {
    textAlign: "right",
    fontSize: 18,
    fontWeight: "bold"
  }
}
